<template>
  <div>
    <cabecalho title="ACADEMICO_MATRICULAS.ENDERECOS" title_type="body" />
    <div class="col-xl-12 flex mb-4" style="display: flex;">
      <input-checkbox
        disabled
        :title="$t('GERAL.MARCAR_TODOS')"
        v-model="aluno.mesmoEnderecoResponsavelFinanceiro"
        :aria-label="$t('GERAL.MARCAR_TODOS')"
        aria-describedby="checkbox-label"
      />
      <span>Mesmo endereço do resposável financeiro</span>
    </div>
    <b-table
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      :items="aluno.enderecos"
      :fields="campos"
      show-empty
      responsive
      striped
      hover
    >
    </b-table>
  </div>
</template>
<script>
// Components:
import { Cabecalho } from '@/components/headers/index';
import { InputCheckbox } from '@/components/inputs';

export default {
  props: {
    aluno: { type: Object, default: Object },
  },
  components: { Cabecalho, InputCheckbox },
  data() {
    return {
      campos: [
        {
          key: 'cep',
          label: this.$t('PESSOAS.CEP'),
        },
        {
          key: 'logradouro',
          label: this.$t('PESSOAS.LOGRADOURO'),
        },
        {
          key: 'numero',
          label: this.$t('PESSOAS.NUMERO'),
        },
        {
          key: 'complemento',
          label: this.$t('PESSOAS.COMPLEMENTO'),
        },
        {
          key: 'tipoEnderecoDescricao',
          label: this.$t('PESSOAS.TIPO_ENDERECO'),
        },
        {
          key: 'principal',
          label: this.$t('PESSOAS.ENDERECO_PRINCIPAL'),
          formatter: (value) => {
            return value ? 'Sim' : 'Não';
          },
        },
      ],
    };
  },
  methods: {},
};
</script>
